<template>
  <div class="add-invoice">
    <div
      class="add-invoice--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="add-invoice__head fw-600 mt-8" :class="{ 'fs-20': breakpointXs, 'fs-25': !breakpointXs }">
      <v-btn icon @click="$router.push({ name: 'dashboard.export.invoice-products' })">
        <v-icon color="black">fas fa-arrow-left</v-icon>
      </v-btn>
      <span>Add Invoice</span>
    </div>
    <div class="add-invoice__body">
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-card elevation="4" class="px-8 py-6 mt-4">
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <TextField
                showIcons
                :showOnlyErrorIcons="true"
                rules="required|max:17"
                v-model="invoiceName"
                :loading="isAddInvoiceFormLoading || savingExportJob"
                label="Invoice Name"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <DateField
                v-model="invoiceDate"
                :showOnlyErrorIcons="true"
                rules="required"
                :inputLabel="'Invoice Date'"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                :items="currencies"
                item-text="name"
                rules="required"
                :return-object="true"
                :loading="isAddInvoiceFormLoading || savingExportJob"
                label="Currency"
                v-model="invoiceCurrencyCodeDropdownValue"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <TextField
                rules="required"
                type="number"
                :loading="isAddInvoiceFormLoading || savingExportJob"
                showIcons
                v-model="exchangeRate"
                :showOnlyErrorIcons="true"
                label="Exchange Rate"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                :return-object="true"
                :items="termsOfInvoices"
                rules="required"
                :loading="isAddInvoiceFormLoading || savingExportJob"
                label="Terms of Invoice"
                item-text="text"
                v-model="natureOfContractDropdownValue"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <TextField
                rules="required"
                type="number"
                showIcons
                :showOnlyErrorIcons="true"
                v-model="invoiceValue"
                :loading="isAddInvoiceFormLoading || savingExportJob"
                label="Total Invoice Value"
              />
            </v-col>
          </v-row>
          <div class="add-invoice__body__table">
            <div class="add-invoice__body__table-body mt-4">
              <div
                class="add-invoice__body__table-body__header d-sm-flex align-center"
                :class="{ 'text-center': breakpointXs }"
              >
                <div
                  class="add-invoice__body__table-body__header--title fw-600"
                  :class="{ 'fs-20': breakpointXs, 'fs-25': !breakpointXs }"
                >
                  Products
                </div>
                <v-spacer v-if="!breakpointXs"></v-spacer>
                <div class="add-invoice__body__table-body__header__search" :class="{ 'mr-4': !breakpointXs }">
                  <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
                </div>
                <div class="add-invoice__body__table-body__header--button" :class="{ 'mt-3': breakpointXs }">
                  <v-btn
                    width="180"
                    color="button-primary"
                    large
                    class="white--text"
                    @click="addProductModalActionHandler"
                    :disabled="invoiceSrNo === null && isNewInvoice"
                  >
                    <v-icon left>fas fa-plus</v-icon>
                    <span class="font-weight-bold fs-15">Add New</span>
                  </v-btn>
                </div>
              </div>
              <div class="add-invoice__body__table-body__table mt-2">
                <v-data-table :items-per-page="5" :headers="tableHeaders" :items="products" :search="search">
                  <template v-slot:item.edit="{ item }">
                    <v-row>
                      <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-right">
                        <v-btn
                          color="lightPrimary"
                          class="info font-weight-bold"
                          dense
                          @click="editProductActionHandler(item)"
                          >Edit</v-btn
                        >
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <v-row>
                      <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-left">
                        <v-btn
                          color="lightPrimary"
                          class=" error font-weight-bold"
                          dense
                          @click="deleteActionHandler(item)"
                          >Delete</v-btn
                        >
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <div
            class="add-invoice__body__action-buttons d-sm-flex justify-end mt-5"
            :class="{ 'text-center': breakpointXs }"
          >
            <v-btn
              width="140"
              color="button-primary"
              outlined
              large
              class="my-3 mr-2"
              :loading="isAddInvoiceFormLoading || savingExportJob"
              @click="$router.push({ name: 'dashboard.export.invoice-products' })"
            >
              <span class="font-weight-bold fs-15">Cancel</span>
            </v-btn>
            <v-btn
              width="140"
              color="button-primary"
              large
              class="white--text my-3"
              :loading="isAddInvoiceFormLoading || savingExportJob"
              @click="passes(addInvoice)"
            >
              <span class="font-weight-bold fs-15">Save</span>
            </v-btn>
          </div>
        </v-card>
      </ValidationObserver>
    </div>
    <AddProductModal
      max-width="1125"
      :itemSrNo="itemSrNo"
      :isNewItem="isNewItem"
      :invoiceSrNo="invoiceSrNo"
      v-if="showAddProductModal"
      @close-product-modal="closeProductModalActionHandler"
    />
    <ConfirmDeleteDialog
      @clicked-yes="deleteProduct"
      @clicked-no="showDeleteConfirmationDialog = false"
      v-if="showDeleteConfirmationDialog"
    />
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import { ValidationObserver } from "vee-validate";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
// import SelectField from "@/components/SelectField";
import AutoComplete from "@/components/AutoComplete";
import AddProductModal from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/AddProductModal";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import { SNACKBAR } from "@/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
export default {
  name: "AddInvoice",
  components: {
    DashboardBreadcrumb,
    TextField,
    DateField,
    // SelectField,
    AutoComplete,
    ConfirmDeleteDialog,
    AddProductModal,
    ValidationObserver
  },
  data() {
    return {
      isAddInvoiceFormLoading: false,
      search: "",
      storeDeleteProduct: "",
      showDeleteConfirmationDialog: false,
      showAddProductModal: false,
      itemSrNo: null,
      isNewInvoice: true,
      isNewItem: true,
      deleteItem: false
    };
  },
  beforeDestroy() {
    this.makeFieldsNull();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    editProductActionHandler(item) {
      this.itemSrNo = item.itemSrNo;
      this.isNewItem = false;
      this.$store.commit(MT.SET_ITEM, item);
      this.showAddProductModal = true;
      return;
    },
    addProductModalActionHandler() {
      if (this.invoiceSrNo === null && this.isNewInvoice) {
        this.$store.dispatch(SNACKBAR, {
          color: "error",
          text: "Kindly fill up and save Invoice Details first please",
          timeout: 3000
        });
        return;
      }
      this.isNewItem = true;
      const currentInvoiceItems = this.$store.getters.exportJob.items.filter(
        item => item.invoiceSrNo == this.invoiceSrNo
      );
      this.$store.commit(MT.SET_ITEM_BLANK);
      this.$store.commit(MT.SET_DRAWBACK_BLANK);
      this.$store.commit(MT.SET_STATEMENT_BLANK);
      this.$store.commit(MT.SET_DFIA_BLANK);
      this.$store.commit(MT.SET_SW_INFO_TYPE_BLANK);
      this.$store.commit(MT.SET_SCHEME_ABBREVIATION_BLANK);
      this.itemSrNo = currentInvoiceItems.length + 1;
      this.showAddProductModal = true;
      return;
    },
    deleteActionHandler(itemToBeRemoved) {
      this.storeDeleteProduct = itemToBeRemoved;
      this.showDeleteConfirmationDialog = true;
      return;
    },
    deleteProduct() {
      const itemToBeRemoved = this.storeDeleteProduct;
      this.$store.commit(MT.REMOVE_ITEM_FROM_EXPORT_JOB, { ...itemToBeRemoved });
      this.$store.commit(MT.REMOVE_ITEM_RELATED_FROM_EXPORT_JOB, { ...itemToBeRemoved });
      this.$store.commit(MT.REASSIGN_ITEMSRNO_TO_ITEM_RELATED_IN_EXPORT_JOB, itemToBeRemoved.itemSrNo);
      this.$store.commit(MT.SORT_SW_INFO_TYPE_IN_EXPORT_JOB);
      this.storeDeleteProduct = null;
      this.showDeleteConfirmationDialog = false;
    },
    addExchangeRate() {
      const exportJobExchangeRates = this.$store.getters.exportJob.exchangeRates;
      const exchangeRateExist = exportJobExchangeRates.find(
        exchangeRate => exchangeRate.invoiceCurrencyCode === this.invoiceCurrencyCode
      );
      if (exchangeRateExist === undefined) {
        // this.$store.commit(MT.SET_EXCHANGE_RATE_CURRENCY_NAME, { value: this.invoiceCurrencyCode });
        this.$store.commit(MT.SET_EXCHANGE_RATE_WHETHER_STANDARD_CURRENCY, { value: "Y" });
        const exchangeRate = { ...this.$store.getters.exchangeRate };
        this.$store.commit(MT.SET_EXCHANGE_RATE_IN_EXPORT_JOB, exchangeRate);
      }
    },
    nullExchangeRateValues() {
      this.$store.commit(MT.SET_EXCHANGE_RATE_EXCHANGE_RATES, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_INVOICE_CURRENCY_CODE, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_CURRENCY_NAME, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_UNIT_IN_RS, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_RATE, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_EFFECTIVE_DATE, null);
      this.$store.commit(MT.SET_EXCHANGE_RATE_WHETHER_STANDARD_CURRENCY, null);
    },
    setBuyerInInvoice() {
      // consigneeAddress3 and consigneeAddress4 are treated as notify party
      const notifyNameAndAddress = [
        this.$store.state.ExportModuleStore.sbMain.consigneeAddress3,
        this.$store.state.ExportModuleStore.sbMain.consigneeAddress4
      ].join("");
      // if the notify name and address are not null
      if (notifyNameAndAddress !== null && notifyNameAndAddress != "") {
        this.$store.commit(MT.SET_INVOICE_BUYER_NAME, {
          value: notifyNameAndAddress.substring(0, parseInt(notifyNameAndAddress.length / 2))
        });
        this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS1, {
          value: notifyNameAndAddress.substring(parseInt(notifyNameAndAddress.length / 2), notifyNameAndAddress.length)
        });
        this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS2, { value: null });
        this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS3, { value: null });
        this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS4, { value: null });
        return;
      }
      // else it will set values by default as consignee
      this.$store.commit(MT.SET_INVOICE_BUYER_NAME, {
        value: this.$store.state.ExportModuleStore.sbMain.consigneeName
      });
      this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS1, {
        value: this.$store.state.ExportModuleStore.sbMain.consigneeAddress1
      });
      this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS2, {
        value: this.$store.state.ExportModuleStore.sbMain.consigneeAddress2
      });
      this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS3, {
        value: this.$store.state.ExportModuleStore.sbMain.consigneeAddress3
      });
      this.$store.commit(MT.SET_INVOICE_BUYER_ADDRESS4, {
        value: this.$store.state.ExportModuleStore.sbMain.consigneeAddress4
      });
      return;
    },
    addInvoice() {
      if (this.isNewInvoice) {
        this.invoiceSrNo = this.$store.state.ExportModuleStore.exportJob.invoices.length + 1;
      }
      this.addExchangeRate();
      this.setBuyerInInvoice();
      const invoice = { ...this.$store.getters.invoice };
      this.$store.commit(MT.SET_INVOICES_IN_EXPORT_JOB, invoice);
      this.$store.dispatch(SNACKBAR, {
        color: "success",
        text: "Invoice saved successfully!",
        timeout: 3000
      });
      this.isNewInvoice = false;
      this.saveExportJob();
      return;
    },
    makeFieldsNull() {
      this.invoiceName = null;
      this.invoiceDate = null;
      this.exchangeRate = null;
      this.invoiceCurrencyCode = null;
      this.natureOfContract = null;
      this.invoiceValue = null;
      return;
    },
    closeProductModalActionHandler() {
      this.showAddProductModal = false;
    },
    setInvoiceAsNull() {},
    checkIfEditInvoice() {
      const invoiceSrNoParam = this.$route.params.invoiceSrNo;
      this.isNewInvoice = true;
      if (parseInt(invoiceSrNoParam) > 0) {
        const index = invoiceSrNoParam - 1;
        const invoices = this.$store.getters.exportJob.invoices;
        if (invoices[index] !== undefined) {
          const invoice = invoices[index];
          this.$store.commit(MT.SET_INVOICE, invoice);
          this.isNewInvoice = false;
          return;
        }
      }
    }
  },
  computed: {
    products() {
      if (this.invoiceSrNo !== null) {
        return this.$store.getters.exportJob.items.filter(item => item.invoiceSrNo === this.invoiceSrNo);
      } else {
        return [];
      }
    },
    invoiceSrNo: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceSrNo;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_SR_NO, { value });
      }
    },
    invoiceName: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceName;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_NAME, { value });
      }
    },
    invoiceDate: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceDate;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_DATE, { value });
      }
    },
    exchangeRate: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.exchangeRate;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_EXCHANGE_RATE, { value });
      }
    },
    invoiceCurrencyCode: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceCurrencyCode;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_CURRENCY_CODE, { value });
        this.$store.commit(MT.SET_EXCHANGE_RATE_INVOICE_CURRENCY_CODE, { value });
      }
    },
    invoiceCurrencyCodeDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceCurrencyCodeDropdownValue;
      },
      set(invoiceCurrencyCodeObject) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_CURRENCY_CODE_DROPDOWN_VALUE, {
          value: invoiceCurrencyCodeObject.name
        });
        this.exchangeRate = invoiceCurrencyCodeObject.exchangeRate;
        this.invoiceCurrencyCode = invoiceCurrencyCodeObject.code;
        return;
      }
    },
    natureOfContractDropdownValue: {
      get() {
        const selectednatureOfContract = this.natureOfContract;
        if (selectednatureOfContract !== "" && !!selectednatureOfContract) {
          return this.termsOfInvoices.find(type => type.textIdentifier.includes(selectednatureOfContract)).text;
        } else {
          return this.termsOfInvoices;
        }
      },
      set(natureOfContractObject) {
        this.$store.commit(MT.SET_INVOICE_NATURE_OF_CONTRACT, { value: natureOfContractObject.text });
      }
    },
    natureOfContract: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.natureOfContract;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_NATURE_OF_CONTRACT, { value });
      }
    },
    invoiceValue: {
      get() {
        return this.$store.state.ExportModuleStore.invoice.invoiceValue;
      },
      set(value) {
        this.$store.commit(MT.SET_INVOICE_INVOICE_VALUE, { value });
      }
    },

    tableHeaders() {
      return [
        { text: "Sr No", value: "itemSrNo", align: "center" },
        { text: "Description", value: "descriptionOfGoods1", align: "center" },
        { text: "RITC Code", value: "ritcCode", align: "center" },
        { text: "Quantity", value: "quantity", align: "center" },
        { text: "Unit Price", value: "unitPrice", align: "center" },
        { text: "Unit", value: "unitOfMeasurement", align: "center" },
        { text: "Edit", value: "edit", align: "center" },
        { text: "Delete", value: "delete", align: "center" }
      ];
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "Invoices & Products",
                  route: "dashboard.export.invoice-products",
                  children: [
                    {
                      title: "Add Invoice",
                      route: "dashboard.export.invoice-products.add-invoice"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ];
    },
    currencies() {
      return this.$store.getters.currencies;
    },
    termsOfInvoices() {
      return this.$store.getters.termsOfInvoices;
    }
  },
  mounted() {
    this.checkIfEditInvoice();
  }
};
</script>
<style lang="scss">
@import "../../../../../../../styles/settings/index";

.add-invoice {
  &__body__table-body {
    border: 2px solid $border-grey;
    padding: 2rem;
    border-radius: 10px;
    &__table {
      .v-data-table {
        background: transparent !important;
      }
    }
  }
}
</style>
